module.exports = __webpack_public_path__ + "static/img/policy-manual-wizard-icon.16e08b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/tools/policy-manual-wizard-icon.png
// module id = eDQa
// module chunks = 0